import { z } from "zod";
import { paycardSSNVerificationHistorySchema } from "./schemas";
import { ESSNVerificationStatus, TSSNVerificationStatus } from "../kyc";

export const EVeriffSSNVerificationStatus = {
  approved: ESSNVerificationStatus.approved,
  declined: ESSNVerificationStatus.declined,
  compliance_approved: ESSNVerificationStatus.compliance_approved,
  compliance_declined: ESSNVerificationStatus.compliance_declined,
} as const;

export const EPersonaSSNVerificationStatus = {
  approved: "passed",
  declined: "failed",
  compliance_approved: ESSNVerificationStatus.compliance_approved,
  compliance_declined: ESSNVerificationStatus.compliance_declined,
} as const;

export const EPaycardSSNVerificationStageID = {
  initial: "initial",
  id_verification: "id_verification",
  id_verification_internal_review: "id_verification_internal_review",
  social_security_card_verification: "social_security_card_verification",
  social_security_card_internal_review: "social_security_card_internal_review",
  internal_decision: "internal_decision",
} as const;

export type TVeriffSSNVerificationStatus =
  (typeof EVeriffSSNVerificationStatus)[keyof typeof EVeriffSSNVerificationStatus];

export type TPersonaSSNVerificationStatus =
  (typeof EPersonaSSNVerificationStatus)[keyof typeof EPersonaSSNVerificationStatus];

export type TPaycardSSNVerificationStageID =
  (typeof EPaycardSSNVerificationStageID)[keyof typeof EPaycardSSNVerificationStageID];

export type TPaycardSSNVerificationHistory = z.infer<
  typeof paycardSSNVerificationHistorySchema
>;

export const paycardSSNVerificationStageIDs: TPaycardSSNVerificationStageID[] =
  Object.values(EPaycardSSNVerificationStageID);

export const paycardSSNVerificationStatusToStateIDMap: Partial<
  Record<TSSNVerificationStatus, TPaycardSSNVerificationStageID>
> = {
  [ESSNVerificationStatus.id_verification_required]:
    EPaycardSSNVerificationStageID.id_verification,
  [ESSNVerificationStatus.id_verification_internal_review_pending]:
    EPaycardSSNVerificationStageID.id_verification_internal_review,
  [ESSNVerificationStatus.social_security_card_required]:
    EPaycardSSNVerificationStageID.social_security_card_verification,
  [ESSNVerificationStatus.social_security_card_internal_review_pending]:
    EPaycardSSNVerificationStageID.social_security_card_internal_review,
};

export const getPreviousSSNVerificationStage = (
  currentStage: TPaycardSSNVerificationStageID
): TPaycardSSNVerificationStageID | null => {
  const currentStageIndex =
    paycardSSNVerificationStageIDs.indexOf(currentStage);
  if (currentStageIndex <= 0) {
    return null;
  }
  return paycardSSNVerificationStageIDs[currentStageIndex - 1];
};

export const getNextPaycardSSNVerificationStage = (
  currentStage: TSSNVerificationStatus
): TPaycardSSNVerificationStageID | null => {
  const currentStageID = paycardSSNVerificationStatusToStateIDMap[currentStage];

  if (!currentStageID) {
    return null;
  }
  const currentStageIndex =
    paycardSSNVerificationStageIDs.indexOf(currentStageID);
  if (currentStageIndex === -1) {
    return null;
  }
  return paycardSSNVerificationStageIDs[currentStageIndex + 1];
};
